import { Image, ImageProps } from 'expo-image'
import React, { useState } from 'react'

type Props = {
  placeholder?: React.JSX.Element
} & ImageProps

const CacheableImage = ({ source, placeholder, ...props }: Props) => {
  const [error, setError] = useState(!source)
  const onError = () => setError(true)

  if (error) {
    return placeholder
  }

  return <Image source={source} {...props} onError={onError} />
}

export default CacheableImage
